import { auth } from "../config/fire";

import React, { Component } from 'react'


export function signup(remail, rpwd) {
  return auth().createUserWithEmailAndPassword(remail, rpwd);
}

export function signout(){
  return auth().signOut();

}

export function signin(lemail, lpwd) {
  return auth().signInWithEmailAndPassword(lemail, lpwd);
}
export function signInWithGoogle() {
  const provider = new auth.GoogleAuthProvider();
  return auth().signInWithPopup(provider);
}

export function updateprof(uname){
  var user = auth().currentUser;
  return user.updateProfile({
    displayName: uname,
  })
}
export function updatephoto(upic){
  var user = auth().currentUser;
  user.updateProfile({
    photURL: upic,
  })
}